export class SearchParameters {
  public fechaTramiteDesde: string;
  public fechaTramiteHasta: string;
  public radicado: string;
  public tipoTramite: string;
  public tipoIdentificacionAfiliado: string;
  public identificacionAfiliado: string;
  public estadoTramite: string;

  public idfEmpresa: string;
  public tipoIdfAfiliado: string;
  public idfAfiliado: string;
  public currentProfileName: string;

  constructor() { }
}
